<template>
	<div v-if="data">
		<div
			:class="{
				marked: isMarked(),
				['affair-list-item_group-task']: isGroupTask
			}"
			class="affair-list-item"
			@click.stop="editTask"
		>
			<div class="list-item-top">
				<div v-if="!isGroupTask" class="dates-wrapper">
					<b
						v-if="data.order && data.order.id"
						:class="{ completed: data.is_completed }"
						>{{ $t("order") }} № {{ data.order.id }}</b
					>

					<div v-else class="description-wrapper w-full">
						<b>{{ getTime(data.date_time) }}</b>
						<p
							:class="{ completed: data.is_completed }"
							class="description-wrapper__text"
						>
							{{ data.description }}
						</p>
					</div>
				</div>

				<div class="controls-wrapper" @click.stop>
					<feather-icon
						v-if="!isGroupTask"
						icon="MessageSquareIcon"
						class="controls-wrapper__chat"
						@click="openComments"
					></feather-icon>

					<feather-icon
						v-if="$store.getters['isAdmin'] && !data.is_by_admin"
						icon="UserPlusIcon"
						size="30"
						svgClasses="h-5 w-5"
						@click.stop="assignToManager"
					/>

					<vs-checkbox
						@click.stop
						@input="changeTaskState($event)"
						v-model="data.is_completed"
						class="inline-flex m-0"
					></vs-checkbox>

					<div class="list-item-top__right">
						<feather-icon
							v-if="
								$store.getters['isAdmin'] || !data.is_by_admin
							"
							@click.stop="deleteTask"
							icon="Trash2Icon"
							size="30"
							svgClasses="h-5 w-5"
						/>
					</div>
				</div>
			</div>

			<div class="list-item-bottom">
				<div
					class="description-wrapper"
				>
					<div v-if="isGroupTask" class="description-wrapper__date">
						<p>{{ getDate(data.date_time) }}</p>

						<b>{{ getTime(data.date_time) }}</b>
					</div>

					<b v-else>{{ getTime(data.date_time) }}</b>

					<p
						:class="{ completed: data.is_completed }"
						class="description-wrapper__text"
					>
						{{ data.description }}
					</p>
				</div>

				<p
					v-if="data.is_by_admin && !$store.getters['isAdmin']"
					class="provided-by-admin"
				>
					{{ $t("setByAdmin") }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "AffairListItem",
	props: {
		data: {
			type: Object
		},
		isGroupTask: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		openComments() {
			this.$emit("openComments");
		},

		getTime(datetime) {
			if (!datetime) {
				return "";
			}

			const [date, time] = datetime.split(" ");
			const [h, m] = time.split(":");
			return `${h}:${m}`;
		},

		getDate(datetime) {
			if (!datetime) {
				return "";
			}

			const [date, time] = datetime.split(" ");
			return date;
		},

		async changeTaskState(e) {
			setTimeout(() => {
				if (e) {
					this.$store.dispatch(
						"calendar/setTaskCompleted",
						this.data
					);
				} else this.$store.dispatch("calendar/reopenTask", this.data);
			}, 300);
		},

		deleteTask() {
			this.$store.dispatch("calendar/deleteTask", this.data);
		},

		assignToManager() {
			this.$emit("assignToManager", this.data);
		},

		editTask() {
			this.$emit("editTask", this.data);
		},

		isMarked() {
			const taskDate = this.data.date_time;
			const currentDate = moment(new Date()).format("YYYY-MM-DD");
			return currentDate > taskDate;
		}
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.affair-list-item {
	background-color: red;
	padding: 1rem;
	width: 100%;
	display: flex;
	cursor: pointer;
	flex-direction: column;
	background-color: #f1f1f166;
	border-top: 1px solid #ddd;

	&_group-task {
		flex-direction: row-reverse;
		justify-content: space-between;
		grid-column-gap: 10px;
	}

	&.marked {
		background-color: #f4a9a9;
	}

	.completed {
		text-decoration: line-through;
	}

	&:last-of-type {
		border-bottom: 1px solid #ddd;
	}

	.list-item-top {
		display: flex;
		// flex-grow: 1;
		margin-bottom: 8px;
		justify-content: space-between;

		b {
			flex-grow: 1;
		}

		.controls-wrapper {
			display: flex;
			align-items: center;
			grid-column-gap: 10px;

			&__chat {
				cursor: pointer;

				svg {
					width: 30px;
					height: 30px;
					fill: white;
					stroke: white;
				}
			}
		}

		&__right {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
		}
	}

	.list-item-bottom {
		display: flex;

		.description-wrapper {
			display: flex;
			flex-grow: 1;
			grid-column-gap: 10px;

			&__date {
				white-space: nowrap;
			}

			&__text {
				word-break: break-word;
			}

			b {
				margin-right: 1rem;
			}
		}

		.provided-by-admin {
			font-size: 10px;
			width: 15%;
			margin-right: 10px;
		}
	}

	.vs-checkbox {
		background-color: white;
		border-color: #6f6f6f !important;
	}
}
</style>
